/* tslint:disable */
/* eslint-disable */
/**
 * Project Client API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ProjectTermsResource
 */
export interface ProjectTermsResource {
    /**
     * 
     * @type {string}
     * @memberof ProjectTermsResource
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof ProjectTermsResource
     */
    url: string;
}

/**
 * Check if a given object implements the ProjectTermsResource interface.
 */
export function instanceOfProjectTermsResource(value: object): value is ProjectTermsResource {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('url' in value) || value['url'] === undefined) return false;
    return true;
}

export function ProjectTermsResourceFromJSON(json: any): ProjectTermsResource {
    return ProjectTermsResourceFromJSONTyped(json, false);
}

export function ProjectTermsResourceFromJSONTyped(json: any, ignoreDiscriminator: boolean): ProjectTermsResource {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'url': json['url'],
    };
}

export function ProjectTermsResourceToJSON(value?: ProjectTermsResource | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'id': value['id'],
        'url': value['url'],
    };
}

